define(["configurator-zone",
  "delay-visible",
  "fade-in-text",
  "fade-visible",
  "format-money",
  "numeric-price",
  "numeric",
  "replace-server-template",
  "stop-binding",
  "visibility"
], 
function(){

});

